import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    retoma_form: {
        lugar_inspeccion: null,
        encargado: null,
        fecha_inspeccion: null,
        hora_inspeccion: null,
    },
    retomador_form: {
        nombre_retomador: null,
        celular_retomador: null,
        oferta_retomador: null
    },
    retoma_documentos: [],
    oferta_vendedor: 0,
    nuevo_presupuesto: 0,
    checklist_retoma: [],
    checklist_retoma_tareas: [],
    credito_historial: []
};
const mutations = {
    updateField,
    updateNegociacion: (state, payload) => {
        var size = Object.keys(payload.negociacion).length;
        if (size > 0) {
            state.retoma_form = payload.negociacion.retoma_form;
            state.nuevo_presupuesto = payload.necesidad.basico.presupuesto;
            state.retomador_form = payload.negociacion.retomador_form;
            state.oferta_vendedor = payload.negociacion.oferta_vendedor;
            state.checklist_retoma = payload.negociacion.checklist_retoma;
            state.checklist_retoma_tareas = payload.negociacion.checklist_retoma_tareas;
        }
    },
    updateDocumentos: (state, payload) => {
        state.retoma_documentos = [...state.retoma_documentos, payload];
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
